import React from "react";
import { Quote, ArrowRight } from "lucide-react";
import { ScrollAnimation } from "../ScrollAnimation";

export default function Results() {
  const benefits = [
    "Redução consistente dos sintomas em diferentes transtornos psiquiátricos",
    "Maior compreensão de si e dos próprios padrões emocionais e comportamentais",
    "Desenvolvimento de regulação emocional e maior estabilidade interna",
    "Melhora do sono, da energia e da organização do cotidiano",
    "Retomada da capacidade de enfrentamento e tomada de decisões",
    "Melhora nas relações e sensação de reconexão com a vida",
  ];

  return (
    <section id="resultados" className="py-20 sm:py-24 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-6xl mx-auto">
        <ScrollAnimation animation="fade-up">
          <span className="font-sans text-sm font-semibold text-[#C2A44A] tracking-wider uppercase mb-3 block">Resultados</span>
        </ScrollAnimation>
        <ScrollAnimation animation="fade-up" delay={100}>
          <h2 className="font-sans text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-[#204613] mb-8 text-balance leading-tight">
            Transformação que vai além do sintoma: reencontre o equilíbrio e a liberdade interior
          </h2>
        </ScrollAnimation>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-12 items-center mt-10 sm:mt-14">
          <ScrollAnimation animation="fade-right" delay={200}>
            <div className="bg-[#ACC996]/10 border border-[#ACC996]/25 rounded-3xl p-6 sm:p-10 shadow-lg">
              <Quote className="w-10 sm:w-12 h-10 sm:h-12 text-[#C2A44A] mb-6" />
              <p className="font-serif text-base sm:text-lg text-[#3d3d3d] mb-4 leading-relaxed italic">
                "Cheguei à clínica sentindo que carregava o mundo nas costas. Ansiedade, insônia, aquela sensação de que nunca ia dar conta de tudo.
              </p>
              <p className="font-serif text-base sm:text-lg text-[#3d3d3d] mb-4 leading-relaxed italic">
                Aqui, fui acolhida de verdade — não só com remédios, mas com escuta, orientação e um plano feito pra mim.
              </p>
              <p className="font-serif text-base sm:text-lg text-[#3d3d3d] mb-4 leading-relaxed italic">
                Aprendi a entender minha mente, a lidar com meus sentimentos e, principalmente, a me reconectar comigo mesma.
              </p>
              <p className="font-serif text-base sm:text-lg text-[#3d3d3d] mb-6 leading-relaxed italic">
                Hoje, tenho mais leveza, clareza e força pra viver. Sou grata por ter encontrado um cuidado tão humano e transformador."
              </p>
              <div className="border-t border-[#ACC996]/30 pt-5">
                <p className="font-sans font-semibold text-[#204613]">— Clara, 38 anos</p>
                <p className="font-serif text-sm text-[#698658]">Florianópolis</p>
              </div>
            </div>
          </ScrollAnimation>

          <ScrollAnimation animation="fade-left" delay={300}>
            <div className="relative h-72 sm:h-96 lg:h-full min-h-72 lg:min-h-[480px] rounded-3xl overflow-hidden shadow-lg">
              <img
                src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/PHOTO-2026-04-14-23-12-26-AqVRZDUo16f1xk4IMPAqJzpnuQqczH.jpg"
                alt="Mulher sorrindo com braços abertos"
                className="w-full h-full object-cover rounded-3xl"
              />
            </div>
          </ScrollAnimation>
        </div>

        <ScrollAnimation animation="fade-up" delay={400}>
          <p className="font-sans text-xl sm:text-2xl font-bold text-[#204613] mt-14 sm:mt-16 mb-10 text-center">
            Benefícios percebidos pelos pacientes
          </p>
        </ScrollAnimation>

        <div className="relative">
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-gradient-to-b from-[#C2A44A] via-[#ACC996] to-[#C2A44A] transform -translate-x-1/2"></div>

          <div className="flex flex-col gap-6 sm:gap-8">
            {benefits.map((benefit, idx) => (
              <ScrollAnimation key={idx} animation={idx % 2 === 0 ? "fade-right" : "fade-left"} delay={450 + idx * 100}>
                <div className={`flex items-center gap-4 md:gap-8 ${idx % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"}`}>
                  <div className={`flex-1 ${idx % 2 === 0 ? "md:text-right" : "md:text-left"}`}>
                    <div className={`bg-gradient-to-br from-[#f5f0e4] to-[#ACC996]/10 border border-[#C2A44A]/25 rounded-2xl p-5 sm:p-6 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 inline-block max-w-md ${idx % 2 === 0 ? "md:ml-auto" : "md:mr-auto"}`}>
                      <p className="font-serif text-base sm:text-lg font-medium text-[#204613] leading-relaxed">{benefit}</p>
                    </div>
                  </div>
                  <div className="hidden md:flex items-center justify-center w-5 h-5 rounded-full bg-[#C2A44A] border-4 border-white shadow-lg z-10 flex-shrink-0">
                    <div className="w-2 h-2 rounded-full bg-white"></div>
                  </div>
                  <div className="hidden md:block flex-1"></div>
                </div>
              </ScrollAnimation>
            ))}
          </div>
        </div>

        <ScrollAnimation animation="scale" delay={700}>
          <div className="mt-10 sm:mt-12 text-center">
            <a
              href="#contato"
              className="inline-flex items-center gap-2 px-6 sm:px-8 py-3 sm:py-4 bg-[#C2A44A] text-white rounded-xl font-sans font-semibold text-sm sm:text-base hover:bg-[#b3943f] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105"
            >
              Agendar Consulta
              <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </ScrollAnimation>
      </div>
    </section>
  );
}
